import appEvents from 'events/app';

export default (async function reconnectChatClient(dispatch, getState, { chatGateway }) {
  dispatch(appEvents.chatClientReconnect());
  await chatGateway.reconnect();
});
